// extracted by mini-css-extract-plugin
export default {"info":"fileuploader_info__6CeGh","filuploadinput":"fileuploader_filuploadinput__DKjjK"};